import { connect } from 'react-redux';
import PartnersComponent from '../components/PartnersComponent';
import { getPartnersDataIfNeeded } from '../actions/partnersActions';

const mapStateToProps = (state) => ({
    partnersData: state.partners.partnersData,
    isLoading: state.partners.isLoading,
});
const mapDispatchToProps = (dispatch) => ({
    getPartnersDataIfNeeded: () => {
        dispatch(getPartnersDataIfNeeded());
    },
});
const JournalistsPageContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(PartnersComponent);

export default JournalistsPageContainer;
